import { useState, useCallback, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { authAction, authSelector } from '../../features/auth/slice';
import { User, Lock, LogIn } from 'lucide-react';
import { PAPER_BASE } from './config';

export default function PaperLoginPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { me, userType } = useSelector(authSelector.selectAuthState);

  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');

  const doLogin = () => {
    axios
      .post(`${process.env.REACT_APP_API_URL}/auth/member/login`, { loginId, password, site: 'paper' })
      .then((response) => {
        if (response.data.token) {
          localStorage.setItem('token', response.data.token);
          axios.get('/auth/me').then((res) => {
            dispatch(authAction.changeMe(res.data));
            navigate(PAPER_BASE || '/');
          });
        } else {
          alert(response.data.message || '아이디/비밀번호를 확인하세요.');
        }
      })
      .catch((err) => {
        alert(err.response?.data?.message || '로그인에 실패했습니다.');
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    doLogin();
  };

  const getMe = useCallback(() => {
    const token = localStorage.getItem('token');
    if (token && !me) {
      dispatch(authAction.setLoading(true));
      axios
        .get('/auth/me')
        .then((res) => dispatch(authAction.changeMe(res.data)))
        .finally(() => dispatch(authAction.setLoading(false)));
    }
  }, [dispatch, me]);

  useEffect(() => { getMe(); }, [getMe]);

  useEffect(() => {
    if (me && userType === 'member') {
      navigate(PAPER_BASE || '/');
    }
  }, [me, userType, navigate]);

  return (
    <div className="bg-[#0d0b14] min-h-[70vh] flex justify-center items-center py-12 px-4">
      <div className="w-full max-w-sm">
        <div className="bg-[#0d0b14] rounded-t-2xl px-8 pt-8 pb-6 border border-white/[0.08] border-b-0">
          <h1 className="text-white text-2xl font-bold tracking-tight">로그인</h1>
          <p className="text-slate-400 text-sm mt-1">핑크페이퍼에 오신 것을 환영합니다</p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-[#1a1428] rounded-b-2xl px-8 py-8 space-y-5 border border-white/[0.08] border-t-0">
          <div className="space-y-1.5">
            <label className="text-xs font-semibold text-slate-400 uppercase tracking-wide">아이디</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                <User size={15} className="text-slate-500" />
              </div>
              <input
                type="text"
                className="w-full pl-9 pr-4 py-2.5 rounded-xl border border-white/[0.08] bg-[#221a38] text-sm text-slate-200 placeholder-slate-500 outline-none focus:ring-2 focus:ring-violet-500/30 focus:border-transparent transition"
                placeholder="아이디를 입력하세요"
                value={loginId}
                onChange={(e) => setLoginId(e.target.value)}
                autoComplete="username"
              />
            </div>
          </div>

          <div className="space-y-1.5">
            <label className="text-xs font-semibold text-slate-400 uppercase tracking-wide">비밀번호</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                <Lock size={15} className="text-slate-500" />
              </div>
              <input
                type="password"
                className="w-full pl-9 pr-4 py-2.5 rounded-xl border border-white/[0.08] bg-[#221a38] text-sm text-slate-200 placeholder-slate-500 outline-none focus:ring-2 focus:ring-violet-500/30 focus:border-transparent transition"
                placeholder="비밀번호"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </div>
          </div>

          <button
            type="submit"
            className="w-full flex items-center justify-center gap-2 px-4 py-3 mt-2 bg-violet-500 hover:bg-violet-600 text-white text-sm font-semibold rounded-xl transition-colors duration-200 cursor-pointer">
            <LogIn size={16} />
            로그인
          </button>

          <p className="text-center text-sm text-slate-400 mt-2">
            아직 회원이 아니신가요?{' '}
            <Link to={`${PAPER_BASE}/register`} className="text-violet-400 hover:text-violet-300 hover:underline">
              회원가입
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
